module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./AccoumulateArriveView.js"));
	}, "AccoumulateArriveView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AccoumulateArriveView!./src/pages/Promote/BusinessCard/AccoumulateArrive/AccoumulateArriveView.js
// module id = 1637
// module chunks = 418